module.exports = __webpack_public_path__ + "4a33a357d3321b9f5997d1845197f822.png";